import styled from '@emotion/styled';
import { useRef, useState } from 'react';
import CrossIcon from '@assets/svg/match/attending.svg';
import { useI18n } from '@i18n/useI18n';

export interface IProps {
  handleSwipe?: () => void;
  style?: any;
}

const SwipeButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  background: ${props => props.theme.colors.placeholderColor};
  border-radius: 30px;
  overflow: hidden;
  margin-top: 30px;
  margin-bottom: 20px;
`;

const DragButton = styled.div<{ posX: number }>`
  height: 40px;
  width: calc(40px + ${(props) => props.posX}px);
  background: #fff;
  border-radius: 40px;
  overflow: hidden;
  position: absolute;
  top: 50%;
  left: calc(4px);
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    position: absolute;
    right: 19px;
    transform: translateX(50%);
    height: 50%;
    path {
      fill: ${props => props.theme.colors.placeholderColor};
    }
  }
`;

const Text = styled.span`
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 52px;
  font-size: 20px;
  color: #fff;
  font-weight: 700;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  pointer-events: none;
  display:block;
`;

const RedeemSwipe = (props: IProps) => {
  const i18n = useI18n();
  const swipeContainer = useRef<HTMLDivElement>();
  const dragPoint = useRef<HTMLDivElement>();
  const [posX, setPosX] = useState({ new: 0, old: 0 });
  const moving = useRef(null);
  const pos = useRef(0);

  const onMouseDown = (e) => {
    dragPoint.current.style.transition = '';
    let r = dragPoint.current.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) moving.current = true;
    else moving.current = false;
  };

  const onTouchStart = (e) => {
    dragPoint.current.style.transition = '';
    let r = dragPoint.current.getBoundingClientRect();
    if (
      e.touches[0].clientX >= r.left &&
      e.touches[0].clientX <= r.right &&
      e.touches[0].clientY >= r.top &&
      e.touches[0].clientY <= r.bottom
    )
      moving.current = true;
  };

  const onTouchMove = (e) => {
    if (moving.current) {
      let width = swipeContainer.current.clientWidth - 8 - 40;
      pos.current = Math.min(Math.max(e.touches[0].clientX - dragPoint.current.getBoundingClientRect().x - 40, 0), width);
      setPosX({ new: pos.current, old: posX.new });
    }
  };

  const onMouseMove = (e) => {
    if (moving.current) {
      let width = swipeContainer.current.clientWidth - 8 - 40;
      pos.current = Math.min(Math.max(e.clientX - dragPoint.current.getBoundingClientRect().x - 16, 0), width);
      setPosX({ new: pos.current, old: posX.new });
    }
  };

  const onEnd = () => {
    moving.current = false;
    let width = swipeContainer.current.clientWidth - 8 - 40;
    if (posX.new < width) {
      dragPoint.current.style.transition = 'width 300ms ease-in-out';
      setPosX({ new: 0, old: posX.new });
    } else {
      props.handleSwipe();
    }
  };

  //onTouchMove={onTouchMove} onMouseMove={onMouseMove} onTouchEnd={onEnd} onMouseUp={onEnd}
  return (
    <SwipeButtonWrapper
      ref={swipeContainer}
      onTouchStart={onTouchStart}
      onMouseLeave={onEnd}
      onMouseDown={onMouseDown}
      onTouchMove={onTouchMove}
      onMouseMove={onMouseMove}
      onMouseUp={onEnd}
      onTouchEnd={onEnd}
    >
      <DragButton ref={dragPoint} posX={posX.new}>
        <CrossIcon />
      </DragButton>
      <Text>{i18n.t('redeem')}</Text>
    </SwipeButtonWrapper>
  );
};

export default RedeemSwipe;
